/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-23 11:22:49
 *
 * LastModified: 2017-05-23 11:22:49
 *-------------------------------------------------------*/
import merge from 'lodash/merge';
import { put, call } from 'redux-saga/effects';
// import { hashHistory } from 'react-router';

import APPCONFIG from 'constants/Config';
import Auth from './Auth';
import LocalStorage from './LocalStorage';

const API_HOST = APPCONFIG.API_HOST;

export function evaluateTimeToLive() {
  const tokenCreatedAt = Auth.tokenCreatedAt();
  const ttl = Auth.ttl();
  if (!tokenCreatedAt || ttl === 0) {
    return false;
  }
  const currentDate = new Date();
  const timeStamp = currentDate.getTime() - (new Date(tokenCreatedAt)).getTime();
  if (process.env.NODE_ENV !== 'production') {
    // console.log('Time to live >>>', ttl - (timeStamp / 1000));
  }
  return timeStamp < ttl * 1000;
}

const fetching = (url, options) => {
  return fetch(API_HOST + url, options)
    .then(response => {
      let res;
      if (options.method === 'DELETE') {
        res = {};
      } else {
        if (response.status === 204) {
          res = {};
        } else {
          res = response.json();
        }
      }
      return res;
    })
    .then(json => {
      if (json.error) {
        throw json.error;
      } else {
        return json;
      }
    })
    .catch(err => {
      throw err;
    });
};

export const uploadImage = function* (url, params) {
  const options = {
    method: 'POST',
    headers: {
      'lang': LocalStorage.getItem('language') === 'ja' ? 'ja' : 'en'
    },
    body: params
  };

  // Set token
  if (Auth.loggedIn()) {
    options.headers.Authorization = Auth.token();
  }

  yield put({ type: 'START_REQUEST' });

  let response;
  try {
    response = yield call(fetching, url, options);
    yield put({ type: 'STOP_REQUEST' });
  } catch (error) {
    response = { error };
    yield put({ type: 'REQUEST_ERROR', payload: error.message || error });
  }
  return response;
};

export const deleteImage = function* (container, file) {
  const options = {
    method: 'DELETE',
    headers: {
      'lang': LocalStorage.getItem('language') === 'ja' ? 'ja' : 'en'
    }
  };

  // Set token
  if (Auth.loggedIn()) {
    options.headers.Authorization = Auth.token();
  }

  // if (params) {
  // 	//options.body = JSON.stringify(params);
  // }

  yield put({ type: 'START_REQUEST' });

  let response;
  try {
    response = yield call(fetching, `attachments/${container}/files/${file}`, options);
    yield put({ type: 'STOP_REQUEST' });
  } catch (error) {
    response = { error };
    // yield put({ type: 'REQUEST_ERROR', payload: error.message || error });
  }
  return response;
};

export default function* (uri, params, opt, background = false) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('uri, params, opt', uri, params, opt);
  }

  // if (uri !== 'Accounts/login' && evaluateTimeToLive() === false) {
  // 	yield put({ type: 'REMOVE_AUTH' });
  // 	window.location.href = '/assets/redirect/index.html';
  // 	yield put({ type: 'STOP_REQUEST' });
  // 	return null;
  // }

  const defaultOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'lang': LocalStorage.getItem('language') === 'ja' ? 'ja' : 'en'
    }
  };

  const options = merge(defaultOptions, opt);

  // Set token
  if (Auth.loggedIn()) {
    options.headers.Authorization = Auth.token();
  }

  let url = uri;

  if (params && Object.keys(params).length > 0) {
    if (options && options.method === 'GET') {
      url += '?' + Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
    } else {
      options.body = JSON.stringify(params);
    }
  }

  if (!background) {
    yield put({ type: 'START_REQUEST' });
  }

  let response;
  try {
    response = yield call(fetching, url, options);

    if (!background) {
      yield put({ type: 'STOP_REQUEST' });
    }
  } catch (error) {
    response = { error };

    if (error.statusCode === 401 && (error.code === 'INVALID_TOKEN' || error.code === 'AUTHORIZATION_REQUIRED')) {
      yield put({ type: 'REMOVE_AUTH' });
      // hashHistory.push('/login');
      window.location.href = '/assets/redirect/index.html';
      yield put({ type: 'STOP_REQUEST' });
    } else {
      console.log(error);
      if (error.statusCode === 422 && error.name === 'ValidationError') {
        yield put({
          type: 'REQUEST_ERROR',
          payload: (error.details && error.details.messages && error.details.messages.email && error.details.messages.email[0]) || error
        });
      } else if (error.statusCode === 401 && error.code === 'LOGIN_FAILED') {
        yield put({
          type: 'REQUEST_ERROR',
          payload: 'The email address or password you entered is wrong'
        });
      } else {
        yield put({ type: 'REQUEST_ERROR', payload: error.message || error });
      }
    }
  }
  return response;
}



// WEBPACK FOOTER //
// ./utils/fetchApi.js